
import * as angular from "angular";

import { IVehicleData } from "./IVehicleData";
import { VehicleDataService } from "./vehicleData.service";

export class FleetMaintenanceController implements angular.IComponentController {
    static $inject = ["$scope", "vehicleDataService"];

    vehicleData: IVehicleData[];
    selectedPage: "summary";
    selectedVehicle: IVehicleData;

    constructor() {
    }

    $onInit(): void {
    }
}
